/**
 * ModuleConfigurationCtrl controller
 */

// preload drag'n'drop image
const dragndropImg = new window.Image()
dragndropImg.src = require('./img/dragndrop.png')

// controller mixins
ModuleConfigurationCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * ModuleConfigurationCtrl controller
 *
 * @class ModuleConfigurationCtrl
 * @memberof mwApp/packages
 * @see mwApp/moduleConfiguration
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/moduleConfiguration.controller:ModuleConfigurationCtrl
 */
/* @ngInject */
export default function ModuleConfigurationCtrl (
  $http,
  $location,
  $scope,
  $state,
  $uibModal,
  ModuleSettings,
  NetworkRow,
  alertSvc,
  authSvc,
  pckg,
  scope
) {
  var vm = this

  vm.LE_ENABLED = window.ENV.APP_LE_ENABLED === 'true'

  ModuleSettings.loadAll({ networkId: pckg.id }).then(res => {
    vm.modules = res
    vm.modules.forEach(m => { m.networkId = pckg.id })
  })

  vm.loadModulesKids = function () {
    ModuleSettings.loadAll({ networkId: pckg.id, params: { moduleTypes: 'KIDS' } }).then(res => {
      vm.modulesKids = res
      vm.modulesKids.forEach(m => { m.networkId = pckg.id })
    })
  }

  vm.loadModulesKids()

  vm.disableAddButton = function (modules, moduleType) {
    if ((moduleType === 'KIDS') && (modules?.length > 4)) return true
    return modules && modules.find(module => module.moduleType === 'CUSTOM')
  }

  /**
   * Whether the "Edit Module" pencil should be shown for a module.
   * Available for all modules when a module object is present.
   *
   * @memberof mwApp/moduleConfiguration.controller:ModuleConfigurationCtrl
   * @function
   * @param {models.ModuleSettings} module
   * @return {Boolean}
   */
  vm.canEditModule = function (module) {
    return !!module
  }

  /**
   * Network
   *
   * @memberof mwApp/moduleConfiguration.controller:ModuleConfigurationCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg

  /**
   * Check, if at least one setting is enabled
   *
   * @memberof mwApp/moduleConfiguration.controller:ModuleConfigurationCtrl
   * @function
   */
  vm.atLeastOneSetting = () => {
    if (!vm.devicesSettings) return true
    return !vm.devicesSettings.reduce((acc, setting) => {
      return acc || setting.value
    }, false)
  }

  vm.mapDevicesSettings = () => {
    const mappedSettings = {}
    vm.devicesSettings.forEach(setting => {
      mappedSettings[setting.key] = setting.value
    })
    return mappedSettings
  }

  vm.settingValidator = () => {
    const devicesSettings = vm.mapDevicesSettings()

    if (!devicesSettings.tvEnabled && devicesSettings.epgEnabled && devicesSettings.catchupEnabled) {
      return 'Please select also Live feature to activate EPG and Catchup feature for your Subscribers'
    }
    if (!devicesSettings.tvEnabled && devicesSettings.epgEnabled) {
      return 'Please select also Live feature to activate EPG feature for your Subscribers'
    }
    if (!devicesSettings.tvEnabled && devicesSettings.catchupEnabled) {
      return `Please select also ${authSvc.hasEnabledFlag('DEV_FEATURE_CLIENT_APP_CHANNEL_TOGGLE_SPLIT_ENABLED') ? 'Live' : 'Live/EPG'} feature to activate Catchup feature for your Subscribers`
    }
    if (authSvc.hasEnabledFlag('NPVR_UI_ENABLED') && devicesSettings.npvrEnabled && (!devicesSettings.tvEnabled || !devicesSettings.catchupEnabled)) {
      return `Please select ${authSvc.hasEnabledFlag('DEV_FEATURE_CLIENT_APP_CHANNEL_TOGGLE_SPLIT_ENABLED') ? 'Live and Catchup' : 'Radio/EPG and Catchup'} features to activate nPVR for your Subscribers`
    }
    if (!devicesSettings.tvEnabled && !devicesSettings.tvShowEnabled && !devicesSettings.vodEnabled) {
      if (vm.LE_ENABLED) {
        if (!devicesSettings.liveEventEnabled) {
          return 'Please select at least one of the following settings: Live, Movies, Series, Live.'
        } else {
          return false
        }
      }
      return 'Please select at least one of the following settings: Channels, Movies, TV Shows'
    }
    return false
  }

  /**
   * Update package/network
   *
   * @memberof mwApp/packages.controller:PackageGeneralSettingsCtrl
   */
  vm.save = function () {
    if (vm.settingValidator()) {
      alertSvc.alert(vm.settingValidator(), 'danger')
      return
    }
    vm.setDisable()
    // save package
    if (!vm.LE_ENABLED) {
      vm.devicesSettings.liveEventEnabled = true
    }
    const logos = vm.logo ? { STB: vm.logo } : {}

    pckg._saveDevicesSettings({ ...vm.mapDevicesSettings(), logos })
      .then(() => {
        alertSvc.alert('Organization settings updated', 'success')
        vm.location.reload()
      })
      .finally(() => {
        vm.unsetDisable()
      })
  }

  vm.back = function () {
    if (vm.location.canPop()) {
      vm.location.back()
    } else {
      $location.url(vm.pckg._publicListUrl)
    }
  }

  vm.addModule = function (moduleType = 'CUSTOM') {
    $location.url(`organizations/${vm.pckg.id}/customization/modules/new?moduleType=${moduleType}`)
  }

  vm.onOff = function (module) {
    const promises = []
    if (module.title === 'Live' && !module.enabled) {
      vm.modules.forEach(m => {
        if (['EPG', 'Catchups'].includes(m.title) && m.enabled) {
          m.enabled = false
          promises.push(m._onOff())
        }
      })
    }
    if (['EPG', 'Catchups'].includes(module.title) && module.enabled) {
      vm.modules.forEach(m => {
        if (m.title === 'Live' && !m.enabled) {
          m.enabled = true
          promises.push(m._onOff())
        }
      })
    }
    Promise.all(promises).then(() => {
      return module._onOff()
    })
  }

  vm.enableMessage = function (module) {
    const liveModule = vm.modules?.find(module => module.title === 'Live')
    if (['Events', 'Movies', 'Series', 'Live'].includes(module.title)) {
      return 'Enabling this module will immediately add it to the Menu in Client Apps — you can review the changes in the General section. Any associated content rows will not be automatically assigned to other modules.'
    }
    if (['EPG', 'Catchups'].includes(module.title) && !liveModule?.enabled) {
      return 'Enabling this module will immediately add it to the Menu in Client Apps.<br/>Live will also be enabled, and any associated content rows will not be automatically assigned to other modules.<br/>You can review the changes in the General section.'
    }
    return 'Enabling this module will immediately add it to the Menu in Client Apps — you can review the changes in the General section.'
  }

  vm.disableMessage = function (module) {
    if (['Events', 'Series', 'Movies'].includes(module.title)) {
      return 'Disabling this module will immediately remove it from the Menu in Client Apps — you can review the changes in the General section. Any associated content rows will be unassigned from other modules, and the content will no longer appear in My List or Search.'
    }
    if (module.title === 'Live') {
      return 'Disabling this module will immediately remove it from the Menu in Client Apps.<br/>Catchups and EPG will also be disabled. You can review the changes in the General section.<br/>Any associated content rows will be unassigned from other modules, and the content will no longer appear in My List or Search.'
    }
    return 'Disabling this module will immediately remove it from the Menu in Client Apps — you can review the changes in the General section.'
  }

  vm.modalClass = function (module) {
    const liveModule = vm.modules?.find(module => module.title === 'Live')
    if (['EPG', 'Catchups'].includes(module.title) && module.enabled && !liveModule?.enabled) {
      return 'text-left'
    }
    if (module.title === 'Live' && !module.enabled) {
      return 'text-left'
    }
    return ''
  }

  vm.delete = function (module) {
    module._delete('Module deleted')
      .finally(vm.loadModulesKids)
  }
}
